inputs-complex-number-and-partition
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      .input-wrap
        span.prefix(if="{opts.prefix}") {opts.prefix}
        input(class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="number" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}" disabled="{disabled: opts.disabled}")
        span.suffix(if="{opts.suffix}") {opts.suffix}
      span.btn-partition.btn.btn-sm.btn-success(onClick="{onClickPartition}") 分配する
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.complex.number-and-partition');
  style(scoped).
    input.form-control {
      display: inline-block;
      width: auto;
    }
    .input-wrap {
      display: inline-block;
      float: left;
    }
    .btn-partition {
     float: right;
    }
